export default "__VITE_ASSET__BlT8iD4M__"